export var CoordCommand = function(eventArg){
	this.showCoord = eventArg;
}
CoordCommand.prototype = {
	constructor : CoordCommand,
	exec : function(scope){
		if (this.showCoord){
                scope.sceneManager.coord.show();
            }
            else{
                scope.sceneManager.coord.hide();    
            }
	}

}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/CoordCommand.js